/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Expected_BagsInputs */

const en_audit_expected_bags = /** @type {(inputs: Audit_Expected_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected Bags`)
};

const es_audit_expected_bags = /** @type {(inputs: Audit_Expected_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sacos Esperados`)
};

/**
* | output |
* | --- |
* | "Expected Bags" |
*
* @param {Audit_Expected_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_expected_bags = /** @type {((inputs?: Audit_Expected_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Expected_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_expected_bags(inputs)
	return es_audit_expected_bags(inputs)
});